<template>
<InputGroup>
    <InputGroupAddon>{{ label }}</InputGroupAddon>
    <InputText 
            :required="required"  
            :disabled="disabled"
            :class="{'p-invalid': isError}"  
            v-model="value" 
            v-on:change="CheckInputAD()" />
</InputGroup>

    
   </template>  
<script>

import EFormService from "../../service/EFormService";


export default {
    props: ['modelValue', 'label', 'disabled', 'BG','required'],
    emits:["update:modelValue"],
    components: {

    },
    data() {
        return {
             value:null,
             isValidate:true,
        }
    },
    EFormService: null,
    created() {
      
        this.EFormService = new EFormService();
        this.value = this.modelValue;
        if(this.value){
                this.CheckInputAD();
             }
        this.$emit("update:error", this.isError);
    },
    computed:{
        isError(){
            return  (this.required && this.required==true) && (!this.value || !this.isValidate);
        }
    },
    watch: {
            value: function (newVal) {
              // watch it
             // console.log("Prop changed: ", newVal, " | was: ", oldVal);
             if(this.value){
                this.CheckInputAD();
             }
             
              this.$emit("update:modelValue", newVal );
              this.$emit("update:error", this.isError);
            },
          },
    methods: {
        
        CheckInputAD() {
            let self=this;
            if(this.value){



                if(this.BG=='PCBG' || this.BG=='SDBG'){
                    this.EFormService.CheckADByBG(this.value,this.BG).then((data) => {
                   // console.log(data)
                    self.isValidate=data;
                    //console.log(data)
                   // console.log(self.isValidateError)
                    this.$emit("update:error", this.isError);
                    })
                }
                else {
                    this.EFormService.CheckAD(this.value).then((data) => {
                   // console.log(data)
                    self.isValidate=data;
                    //console.log(data)
                   // console.log(self.isValidateError)
                    this.$emit("update:error", this.isError);
                    })

                }
                
            }
          
           
        }
    }
}
</script>
  
  